import React from "react";
var __jsx = React.createElement;
import PromoBanner from './PromoBanner';
function PromoBannerAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(PromoBanner, {
    promoData: entry
  });
}
export default PromoBannerAdapter;